import { gql } from '@apollo/client';

export const CREATE_GRAPH = gql`
  mutation CreateGraph($params: CreateGraphInput!) {
    createGraph(params: $params) {
      success
      message
      errors
      data {
        id
        nodes
        tables
        baseTable
        joinCondition
        businessRules
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_GRAPH = gql`
  mutation UpdateGraph($params: UpdateGraphInput!) {
    updateGraph(params: $params) {
      success
      message
      errors
      data {
        id
        nodes
        tables
        baseTable
        joinCondition
        businessRules
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_GRAPH = gql`
  mutation DeleteGraph($params: DeleteGraphInput!) {
    deleteGraph(params: $params) {
      success
      message
      errors
    }
  }
`;
